import to from "await-to-js";
import { t } from "i18next";
import { useContext, useEffect } from "react";

import { Button } from "../../../../../../components/Button/Button";
import { Table } from "../../../../../../components/Table/Table";
import { ModalsContext } from "../../../../../../context/modals.context";
import { ministryService } from "../../../../../../modules/ministry/ministry.service";
import { ExciseWarehouseContext } from "../../../../../../modules/obligee/exciseWarehouse/exciseWarehouse.context";
import { exciseWarehouseService } from "../../../../../../modules/obligee/exciseWarehouse/exciseWarehouse.service";
import { IIstorijaResenjaProps } from "../../../../../../modules/obligee/exciseWarehouse/exciseWarehouse.types";
import { formatDateDDMMYY } from "../../../../../../utils/dateFormatter";
import { downloadFile } from "../../../../../../utils/fileDownload";
import { toastService } from "../../../../../../utils/toast.service";
import style from "./RescriptHistoryTable.module.scss";

export const RescriptHistoryTable = () => {
  const { setError } = useContext(ModalsContext);
  const { exciseWarehouse, setExciseWarehouse } = useContext(
    ExciseWarehouseContext
  );
  const createIstorijaResenjaZaSkladiste = async () => {
    const [err, res] = await to(
      exciseWarehouseService.createIstorijaResenjaZaSkladiste({
        skladisteId: exciseWarehouse.selectedWarehouseId,
      })
    );
    if (err || !res.success) return setError(res?.errorMessage);
    setExciseWarehouse({
      istorijaResenjaZaSkladiste: res.data.resenjaZaSkladiste,
    });
  };

  const createDohvatiDokumentMfin = async (
    dokumentId: number | null,
    tipResenja: string
  ) => {
    const [err, res] = await to(
      ministryService.createDohvatiDokumentMfin({
        documentId: dokumentId,
      })
    );
    if (err || !res.success) return setError(res?.errorMessage);
    toastService.success("TOAST.DOWNLOAD_SUCCESS");
    downloadFile(
      res.data.data,
      tipResenja || "dokument",
      res.data.format as any
    );
  };

  useEffect(() => {
    createIstorijaResenjaZaSkladiste();
  }, []);

  const colDef = [
    { title: t("TABLES.BROJ_RESENJA"), dataIndex: "brojResenja" },
    { title: t("TABLES.TIP_RESENJA"), dataIndex: "tipResenja" },
    {
      title: t("TABLES.DATUM_IZDAVANJA_RESENJA"),
      dataIndex: "datumIzdavanjaResenja",
      render: (datum: string) => formatDateDDMMYY(datum),
    },
    {
      title: t("TABLES.DATUM_DO_KADA_VAZI_RESENJE"),
      dataIndex: "datumVazenjaResenja",
      render: (datum: string) => formatDateDDMMYY(datum),
    },
    {
      title: t("TABLES.PREUZMI_RESENJE"),
      render: (record: IIstorijaResenjaProps) => (
        <Button
          onClick={() =>
            createDohvatiDokumentMfin(record.dokumentId, record.tipResenja)
          }
        >
          {t("TABLES.PREUZMI_RESENJE")}
        </Button>
      ),
    },
  ];
  return (
    <div className={style.mainContainer}>
      <Table
        columns={colDef}
        scrollConfig={[".ant-tabs-nav"]}
        dataSource={exciseWarehouse.istorijaResenjaZaSkladiste}
        name="skladista-istorija-resenja-tabela"
      />
    </div>
  );
};
